// src/utils/conditions.js
import { loadCSVList } from "./csvLoader";

const CONDITION_CANONICAL_MAP = new Map([
  // Legacy typo observed in persisted user data.
  ["hyperthyrodism", "Hyperthyroidism"],
]);

function normalizeKey(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();
}

function toConditionLabel(value) {
  const text = String(value || "").replace(/\s+/g, " ").trim();
  if (!text) return "";
  const mapped = CONDITION_CANONICAL_MAP.get(normalizeKey(text));
  return mapped || text;
}

export function normalizeConditionList(values) {
  const input = Array.isArray(values)
    ? values
    : typeof values === "string"
      ? values
          .split(",")
          .map((value) => value.trim())
          .filter(Boolean)
      : [];
  const seen = new Set();
  const out = [];

  for (const value of input) {
    const label = toConditionLabel(value);
    if (!label) continue;
    const key = normalizeKey(label);
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(label);
  }

  return out;
}

export async function loadConditions() {
  const rows = await loadCSVList("/data/clean/conditions.csv", {
    unique: true,
    sort: true,
    normalize: true,
  });
  return normalizeConditionList(rows).sort((a, b) => a.localeCompare(b));
}
